import { resolveImagePath } from "@/utils/imageMap";

export function Hero() {
  return (
    <section className="relative min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-16">
      {/* Background text overlay - more prominent */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <div className="text-gray-200 font-bold leading-none select-none opacity-30">
          <div className="text-[8rem] md:text-[12rem] lg:text-[16rem] xl:text-[20rem] tracking-wider">
            <span>KENDRA</span>
          </div>
          <div className="text-[6rem] md:text-[9rem] lg:text-[12rem] xl:text-[15rem] text-center -mt-4 md:-mt-8 tracking-wider">
            <span>CAPALBO.LICSW</span>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Portrait image */}
        <div className="mb-8 flex justify-center">
          <div className="w-72 h-80 md:w-80 md:h-96 lg:w-96 lg:h-[28rem] relative">
            <img
              src={resolveImagePath("/images/kendra-portrait.jpg")}
              alt="Kendra Capalbo, LICSW"
              className="w-full h-full object-cover object-center shadow-2xl"
            />
          </div>
        </div>

        {/* Main tagline */}
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-medium text-gray-900 mb-2 tracking-wide">
          YOUR PARTNER IN
        </h1>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-medium text-gray-900 mb-6 tracking-wide">
          NURTURING MEANINGFUL
        </h2>
        <p className="text-lg md:text-xl text-gray-600 italic font-light mb-12">
          Relationships
        </p>

        {/* As seen in section */}
        <div className="mt-16">
          <h3 className="text-sm md:text-base font-medium text-gray-500 mb-8 uppercase tracking-wide">
            AS SEEN IN
          </h3>
          
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-16">
            <img
              src={resolveImagePath("/images/well-good-logo.png")}
              alt="Well+Good"
              className="h-8 md:h-10 w-auto opacity-60 hover:opacity-80 transition-opacity"
            />
            <img
              src={resolveImagePath("/images/escape-logo.png")}
              alt="Escape"
              className="h-8 md:h-10 w-auto opacity-60 hover:opacity-80 transition-opacity"
            />
            <img
              src={resolveImagePath("/images/vice-logo.png")}
              alt="Vice"
              className="h-8 md:h-10 w-auto opacity-60 hover:opacity-80 transition-opacity"
            />
            <img
              src={resolveImagePath("/images/huffpost-logo.png")}
              alt="HuffPost"
              className="h-8 md:h-10 w-auto opacity-60 hover:opacity-80 transition-opacity"
            />
            <img
              src={resolveImagePath("/images/parked-logo.png")}
              alt="Parked"
              className="h-8 md:h-10 w-auto opacity-60 hover:opacity-80 transition-opacity"
            />
          </div>
        </div>
      </div>
    </section>
  );
}